module.exports = __webpack_public_path__ + "img/base_price_ad1.27dad8d3.jpg";